export const language = {
  en: {
    'Change Password': 'Change Password',
    'Current Password': 'Current Password',
    'Please Enter Current Password': 'Please Enter Current Password',
    'New Password': 'New Password',
    'Please Enter New Password': 'Please Enter New Password',
    'Confirm New Password': 'Confirm New Password',
    'Please Confirm New Password': 'Please Confirm New Password',
    'Save': 'Save',
    'Password changed successfully': 'Password changed successfully',
    'At least 6 characters': 'At least 6 characters',
    'Invalid character: ': 'Invalid character: ',
    '6-16 characters, must include at least 3 of: uppercase letters, lowercase letters, numbers, or symbols': '6-16 characters, must include at least 3 of: uppercase letters, lowercase letters, numbers, or symbols',
    'Passwords Do Not Match': 'Passwords Do Not Match',
  },
  zh: {
    'Change Password': '修改密码',
    'Current Password': '原密码',
    'Please Enter Current Password': '请输入原密码',
    'New Password': '新密码',
    'Please Enter New Password': '请输入新密码',
    'Confirm New Password': '确认新密码',
    'Please Confirm New Password': '请确认密码',
    'Save': '保存',
    'Password changed successfully': '密码修改成功',
    'At least 6 characters': '最少6个字符',
    'Invalid character: ': '无效字符：',
    '6-16 characters, must include at least 3 of: uppercase letters, lowercase letters, numbers, or symbols': '6-16位，必须包含大小写字母、数字或符号中的3种',
    'Passwords Do Not Match': '两次密码输入不一致',
  }
};